module.exports = __webpack_public_path__ + "881f41168bb1504f3c929c76e0273d79.png";